export enum TypeFormSurveyID {
  CANCEL_SURVEY_V2 = 'jmk3Aulf'
}
